/*
 Golden Partner Holding Website
 Created by Hu Fang.
 Copyright © GPHolding.ch. All rights reserved.
*/

import Vue from 'vue';
import App from './App.vue';
import router from './router';

import './plugins/element.js';  /*element-ui*/
// import 'element-ui/lib/theme-chalk/display.css';
// import './assets/icon/iconfont.css';
import global_ from './Global.vue'; /*global constant*/
import './utils/rem.js';          /*auto adapt layout*/
import VueI18n from 'vue-i18n';
import en from './assets/localization/en';
import fr from './assets/localization/fr';

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VueI18n);
Vue.use(VideoPlayer);

const defaultLocale = 'fr'; //Default language. global_.$defaultLocale

//create instance for localization framework.
const i18n = new VueI18n({

  // Firstly fetch language from local storage, if not exists, set default language French.
  locale: localStorage.getItem('lang') || defaultLocale,
  fallbackLocale: defaultLocale,         /*when cannot hit any target, use this locale*/
  messages: {
    'en': en, // English string
    'fr': fr  // French string
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
  components: { App },
  template: '<App/>',
}).$mount('#app')

Vue.prototype.GLOBAL = global_;
Vue.prototype.ROUTER = router;
Vue.prototype.Localization = i18n;
